export class UserDto {
  id?: number;
  username?: string;
  full_name?: string;
  email?: string;
  curr_account_id?: number;
  roles?: Array<{
    id?: number;
    rec_status?: string;
    role?: {
      id?: number;
    };
  }>;
  status?: string;
  password_expired?: Date;
  localization?: string;
}
